import RpcResponse from "@/core/services/Rpc/RpcResponse";
import Core from "@/core/Core";
import Person from "@/domains/Persons/Person";

export default class PersonsDAO {
  static async searchPersons(
    pattern: string,
    partnerId?: number
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest(
      "persons.getList",
      {
        pattern,
        partnerId,
      }
    );
  }

  static async get(
    id: number
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest("persons.get", { id });
  }

  static async sendInvite(
    person: Person
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest("persons.sendInvite", { person });
  }

  static async add(
    person: Person,
    partnerId: number
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest("persons.add", { person, partnerId });
  }

  static async update(
    person: Person
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest("persons.update", { person });
  }

  static async delete(
    id: number
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest("persons.delete", { id });
  }
}
